import {Text} from 'platform/foundation';
import styled from 'styled-components';

import {isNil, isNotNil} from 'ramda';
import {isFalse} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface ChartTooltipProps extends TestIdProps {
  isVisible?: boolean;
  left?: number;
  bottom?: number;
  content?: string | null;
  containerWidth?: number | null;
}

export function ChartTooltip(props: ChartTooltipProps) {
  if (isFalse(props.isVisible) || isNil(props.content)) {
    return null;
  }

  return (
    <StyledTooltip
      $left={props.left}
      $bottom={props.bottom}
      $containerWidth={props.containerWidth}
      data-testid={suffixTestId('chartTooltip', props)}
    >
      <Text size="xSmall" color="white" alternative>
        {props.content}
      </Text>
    </StyledTooltip>
  );
}

// eslint-disable-next-line eag/no-css-property
const StyledTooltip = styled.div<{
  $left?: number;
  $bottom?: number;
  $containerWidth?: number | null;
}>`
  position: ${(props) =>
    isNotNil(props.$left) || isNotNil(props.$bottom) ? 'absolute' : 'relative'};
  bottom: ${(props) => props.$bottom}px;

  ${(props) => {
    if (isNil(props.$left)) {
      return;
    }

    // If close to right edge, use right positioning
    if (isNotNil(props.$containerWidth) && props.$left > props.$containerWidth / 2) {
      return `
        right: ${props.$containerWidth - props.$left}px;
        transform: translateX(50%);
      `;
    }

    // Otherwise, use left positioning
    return `
      left: ${props.$left}px;
      transform: translateX(-50%);
    `;
  }};

  max-width: ${(props) => props.theme.getSize(58)};
  background-color: ${(props) => props.theme.colors.palettes.neutral[900][100]};
  border-radius: ${(props) => props.theme.radii.small};
  padding: ${(props) => props.theme.getSize(1)} ${(props) => props.theme.getSize(2)};
  z-index: ${(props) => props.theme.zIndices.TOOLTIP};
  pointer-events: none;
`;
